var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2098_3900",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.188965,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2098_3900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.00033 14.8555C3.63366 14.8555 3.31977 14.7249 3.05866 14.4638C2.79755 14.2027 2.66699 13.8888 2.66699 13.5221V6.85547C2.66699 6.4888 2.79755 6.17491 3.05866 5.9138C3.31977 5.65269 3.63366 5.52214 4.00033 5.52214H4.66699V4.1888C4.66699 3.26658 4.99199 2.48047 5.64199 1.83047C6.29199 1.18047 7.0781 0.855469 8.00033 0.855469C8.92255 0.855469 9.70866 1.18047 10.3587 1.83047C11.0087 2.48047 11.3337 3.26658 11.3337 4.1888V5.52214H12.0003C12.367 5.52214 12.6809 5.65269 12.942 5.9138C13.2031 6.17491 13.3337 6.4888 13.3337 6.85547V13.5221C13.3337 13.8888 13.2031 14.2027 12.942 14.4638C12.6809 14.7249 12.367 14.8555 12.0003 14.8555H4.00033ZM8.00033 11.5221C8.36699 11.5221 8.68088 11.3916 8.94199 11.1305C9.2031 10.8694 9.33366 10.5555 9.33366 10.1888C9.33366 9.82214 9.2031 9.50825 8.94199 9.24714C8.68088 8.98602 8.36699 8.85547 8.00033 8.85547C7.63366 8.85547 7.31977 8.98602 7.05866 9.24714C6.79755 9.50825 6.66699 9.82214 6.66699 10.1888C6.66699 10.5555 6.79755 10.8694 7.05866 11.1305C7.31977 11.3916 7.63366 11.5221 8.00033 11.5221ZM6.00033 5.52214H10.0003V4.1888C10.0003 3.63325 9.80588 3.16102 9.41699 2.77214C9.0281 2.38325 8.55588 2.1888 8.00033 2.1888C7.44477 2.1888 6.97255 2.38325 6.58366 2.77214C6.19477 3.16102 6.00033 3.63325 6.00033 4.1888V5.52214Z",
    fill: "#9B9B9B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.5720c0c3e9922a02c7ffa3e18c99e755.svg";
export { ForwardRef as ReactComponent };